function validate() {
  setTimeout(() => {
    if (document.getElementsByClassName('add-personalizacao')[0].checked == true) {
          document.getElementsByClassName('custom-field')[0].style.display = 'flex';
      } else {
         document.getElementsByClassName('custom-field')[0].style.display = 'none';
      }
  }, "500");    
}

const copyButton = document.getElementById('copyButton');
const originalText = copyButton.textContent;

copyButton.addEventListener('click', () => {
    // Cria um elemento temporário
    const tempInput = document.createElement('textarea');
    tempInput.value = '❤️';
    document.body.appendChild(tempInput);
    
    // Seleciona e copia o texto
    tempInput.select();
    document.execCommand('copy');
    
    // Remove o elemento temporário
    document.body.removeChild(tempInput);
    
    // Feedback visual
    copyButton.textContent = 'Copiado!';
    
    // Volta ao texto original após 2 segundos
    setTimeout(() => {
        copyButton.textContent = originalText;
    }, 2000);
});


/*
window.onload = function(){
  document.querySelector('.magic-video-container video').setAttribute("loop", "true")
}
*/
